import { useIsTreatmentVariantByUser } from "../../utils";

export const useFormation = () => {
  const EXPERIMENT_KEY = "tc-437-use-formation";
  const { isTreatment } = useIsTreatmentVariantByUser(EXPERIMENT_KEY);
  return isTreatment;
};
